import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const YoutubeVideoDescription = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12724"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12724)">
          <rect
            x="-23"
            y="-2"
            width="151"
            height="115"
            rx="4.87097"
            fill="#FEF2F2"
          />
          <path
            d="M60.9924 74.0015H35.4543L20.861 84.9465V74.0015H13.5643C11.6186 74.0015 9.91602 72.2991 9.91602 70.3531V33.87C9.91602 31.9242 11.6186 30.2217 13.5643 30.2217H60.9924C62.9384 30.2217 64.6408 31.9242 64.6408 33.87V70.3531C64.6408 72.2991 62.9384 74.0015 60.9924 74.0015Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="15.3586"
            y="52.7131"
            width="46.8831"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="57.584"
            width="37.1411"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="15.3586"
            y="62.4551"
            width="26.1815"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <circle
            cx="17.7941"
            cy="38.7092"
            r="2.43548"
            fill="#1E1E1E"
          />
          <rect
            x="22.665"
            y="37.4915"
            width="23.1371"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <rect
            x="48.2378"
            y="37.4915"
            width="12.1774"
            height="2.43548"
            rx="0.608871"
            fill="#1E1E1E"
          />
          <path
            d="M48.4525 80.8622H67.0037L77.6046 88.8127V80.8622H82.905C84.3184 80.8622 85.5552 79.6255 85.5552 78.2119V51.71C85.5552 50.2966 84.3184 49.0598 82.905 49.0598H48.4525C47.0389 49.0598 45.8022 50.2966 45.8022 51.71V78.2119C45.8022 79.6255 47.0389 80.8622 48.4525 80.8622Z"
            fill="white"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.9772 72.7728C64.6671 73.5191 65.8429 73.5308 66.5476 72.7985L74.2594 64.7841C75.8495 63.194 76.2029 60.7205 75.3195 58.6003C73.7294 55.4201 69.3124 54.7134 66.8389 57.1869L65.4255 58.6003L64.0119 57.1869C61.3618 54.5367 57.1215 55.2434 55.5313 58.6003C54.4714 60.7205 54.8247 63.194 56.5915 64.7841L63.9772 72.7728Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="0.913306"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.6773 46.0158H9.87891V44.7981H64.6773V46.0158Z"
            fill="black"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            fill="white"
          />
          <rect
            x="73.0492"
            y="21.5453"
            width="31.9657"
            height="31.9657"
            rx="15.9829"
            stroke="#1E1E1E"
            strokeWidth="0.913306"
          />
          <g clipPath="url(#clip0_1529_12724)">
            <path
              d="M89.0264 31.2295C89.0264 31.2295 83.4007 31.2295 81.9887 31.5964C81.2327 31.8076 80.6101 32.4302 80.3989 33.1973C80.032 34.6093 80.032 37.5334 80.032 37.5334C80.032 37.5334 80.032 40.4686 80.3989 41.8584C80.6101 42.6255 81.2215 43.2369 81.9887 43.4482C83.4118 43.8262 89.0264 43.8262 89.0264 43.8262C89.0264 43.8262 94.6633 43.8262 96.0752 43.4593C96.8424 43.2481 97.4538 42.6478 97.6539 41.8695C98.0319 40.4686 98.0319 37.5445 98.0319 37.5445C98.0319 37.5445 98.043 34.6093 97.6539 33.1973C97.4538 32.4302 96.8424 31.8188 96.0752 31.6186C94.6633 31.2295 89.0264 31.2295 89.0264 31.2295ZM87.2364 34.8318L91.9171 37.5334L87.2364 40.2239V34.8318Z"
              fill="#FF0000"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12724">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(80.032 28.5281)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
